import { BybButtonVR, BybDialog } from "@Components/game/common";
import useI18n from "@i18n";
import { DialogProps, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';

interface IDeleteMembersDialog extends Omit<DialogProps, 'onCancel'> {
  members: any[]; //TODO: memberDetails type
  onDelete: () => void;
  onCancel: () => void;
}

const DeleteMembersDialog = ({ members, onDelete, onCancel, ...props }: IDeleteMembersDialog) => {
  const { i18n } = useI18n();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDelete = () => {
    // TODO: Implement delete functionality
    onDelete();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <BybDialog name="assign-role-dialog" maxWidth="lg" onClose={handleCancel} {...props}>
      <Stack spacing={5} sx={{ width: isSmDown ? '100%' : '40vw' }}>
        <Stack spacing={2} sx={{ textAlign: 'center' }}>
          <Typography variant={isSmDown ? 'text1xl700' : 'text4xl800'} color={theme.palette.text.primary}>
            {members.length > 1 ? i18n('settings.members.delete.title') : i18n('settings.member.delete.title')}
          </Typography>
          <Typography variant={isSmDown ? 'textBase500' : 'text1xl500'} color={theme.palette.text.secondary}>
            {members.length > 1
              ? i18n('settings.members.delete.description')
              : i18n('settings.member.delete.description')}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={2} sx={{ pt: isSmDown ? 0 : 3, '> *': { flexGrow: 1 } }}>
          <BybButtonVR color="secondary" onClick={handleCancel} fullWidth>
            {i18n('button.cancel')}
          </BybButtonVR>
          <BybButtonVR
            onClick={handleDelete}
            fullWidth
            sx={{
              backgroundColor: 'dsDestructive.v300',
              '&:hover': {
                backgroundColor: 'dsDestructive.v400',
              },
            }}
          >
            {i18n('button.confirm')}
          </BybButtonVR>
        </Stack>
      </Stack>
    </BybDialog>
  );
};

export default DeleteMembersDialog;

